import { Component, OnInit, ViewChild } from '@angular/core';
import { PlaceModel, PlaceService } from '../place';
import { PlaceDialogComponent } from '../place-dialog/place-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { plainToClass } from 'class-transformer';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { rowAnimation, detailExpand } from '../app.animations';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-place-list-page',
  templateUrl: './place-list-page.component.html',
  styleUrls: ['./place-list-page.component.scss'],
  animations: [
    detailExpand(),
    rowAnimation()
  ],
})
export class PlaceListPageComponent implements OnInit {

  displayedColumns = ['title', 'description', 'shorthandSymbol', 'address', 'delete'];
  dataSource = new MatTableDataSource<PlaceModel>();
  expandedElement: any | null;

  constructor(private service: PlaceService, public dialog: MatDialog) {
    this.service.list().subscribe(
      (data) => {
        this.dataSource.data = data;
      },
      (error) => {},
      () => {}
    );
  }

  ngOnInit(): void {
  }

  add() {
    this.openDialog();
  }

  delete(data: PlaceModel) {
    if (!data._id) { return; }

    const deleteDialogRef = this.dialog.open(DeleteDialogComponent, {
      data: { name: data.title }
    });

    deleteDialogRef.afterClosed().subscribe(result => {
      if (result === undefined || result === null) { return; }
      if (result) {
        this.service.delete(data._id).subscribe({
          next: () => {
            const dataList = this.dataSource.data;
            const index = dataList.findIndex((element) => {
              return element._id && element._id === data._id;
            });
            if (!index) { return; }
            dataList.splice(index, 1);
            this.dataSource.data = dataList;
          },
          error: () => {},
          complete: () => {}
        });
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(PlaceDialogComponent, {
      width: '300px',
      data: new PlaceModel()
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined || result === null) { return; }
      console.log('The dialog was closed');
      this.service.create(result).subscribe(
        (data) => {
          const dataList = this.dataSource.data;
          dataList.push(plainToClass(PlaceModel, data));
          this.dataSource.data = dataList;
        },
        (error) => {},
        () => {}
      );
    });
  }

  openPlace(data: PlaceModel) {
    const dialogRef = this.dialog.open(PlaceDialogComponent, {
      data
    });
    dialogRef.afterClosed().subscribe();
  }

}
